import { TypeT } from "./../app/types/types";
import { TypeQuerySearch } from "../app/index";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { getProducts } from "../features/products/getProducts";
import { useFilterParams } from "./useFilterParams";
import { useUserStore } from "../stores/userStore";
import { calculateMaxFilter } from "../utils/filterUtils";

export const useFetchProducts = (
  token: TypeT | undefined
) => {
  const [currentPage, setCurrentPage] = useState(1);
  const { user } = useUserStore();

  const [querySearch, setquerySearch] = useState<TypeQuerySearch>({
    categories: [],
    keyword: "",
    rangeValue: [0, calculateMaxFilter(user.collections)],
    sortby: 'brand_crescente',
  });

  useFilterParams(setquerySearch, querySearch);

  const result: any = useQuery({
    queryKey: ["products", { currentPage, querySearch, token }],
    queryFn: async () => {
      return (
        token &&
        (await getProducts(
          currentPage,
          "", // excludeCategories sempre vuoto
          querySearch,
          token,
          user.collections,
          user.categories
        ))
      );
    },
    refetchOnWindowFocus: false
  });
  return {
    result,
    currentPage,
    setCurrentPage,
    querySearch,
    setquerySearch,
  };
};

export const PRODUCT_DIGITAL = 'Digitale';
